import { useEffect, useState } from 'react';
import { ArrowLeft, User } from 'lucide-react';
import { supabase } from '@/integrations/supabase/client';
import { useLoginAsUser } from '@/hooks/useLoginAsUser';

const ADMIN_RETURN_SESSION_KEY = 'admin_return_session';

export function AdminReturnBanner() {
  const { returnToAdmin, isLoading } = useLoginAsUser();
  const [currentEmail, setCurrentEmail] = useState<string | null>(null);
  const [adminEmail, setAdminEmail] = useState<string | null>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = sessionStorage.getItem(ADMIN_RETURN_SESSION_KEY);
    if (!stored) {
      setVisible(false);
      return;
    }

    setVisible(true);

    try {
      const parsed = JSON.parse(stored);
      if (parsed?.admin_email) setAdminEmail(parsed.admin_email);
    } catch {
      // sessionStorage JSON malformed — leave adminEmail null, banner still renders without it
    }

    // Get current user email
    supabase.auth.getUser().then(({ data }) => {
      setCurrentEmail(data?.user?.email || 'unknown user');
    });
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] bg-purple-600 text-white px-4 py-2 flex items-center justify-between text-sm shadow-lg">
      <div className="flex items-center gap-2">
        <User className="h-4 w-4" />
        <span>
          Impersonating <strong>{currentEmail}</strong>
          {adminEmail ? <> (as <strong>{adminEmail}</strong>)</> : null}
        </span>
      </div>
      <button
        onClick={() => { setVisible(false); returnToAdmin(); }}
        disabled={isLoading}
        className="flex items-center gap-1.5 px-3 py-1 bg-white/20 hover:bg-white/30 rounded-md transition-colors font-medium disabled:opacity-50"
      >
        <ArrowLeft className="h-3.5 w-3.5" />
        {isLoading ? 'Restoring...' : 'Return to Admin'}
      </button>
    </div>
  );
}
